import React, { FC, ReactElement, Suspense, lazy } from 'react';
import { useFormContext, useController } from 'react-hook-form';

import { IdeaUpdateFormValues } from 'buyside/components/presentation/IdeaShowPage/AuthorActions/ideaUpdateForm';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

import styles from '../authorActionsStyles.scss';

const TinyMCEEditor = lazy(() =>
  import('buyside/components/presentation/TinyMCEEditor/tinyMceEditor')
);

const IdeaUpdateForm: FC<{ date: string }> = ({ date }): ReactElement => {
  const { control, setValue } = useFormContext<IdeaUpdateFormValues>();

  const {
    field: { name, onBlur, ref, value },
    formState: { isSubmitting }
  } = useController({ control, name: 'body' });

  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionHeader}>
        <strong>Enter the details of your update for {date}</strong>
        <span> (Optional)</span>
      </div>
      <div ref={ref} tabIndex={-1}>
        <Suspense fallback={<LoadingSpinner />}>
          <TinyMCEEditor
            disabled={isSubmitting}
            id={name}
            onBlur={onBlur}
            onEditorChange={value => {
              setValue('body', value, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true
              });
            }}
            value={value || ''}
            withImages
          />
        </Suspense>
      </div>
    </div>
  );
};

export default IdeaUpdateForm;
